import React from 'react';
import PropTypes from 'prop-types';
import { ConnectedRouter } from 'react-router-redux';
import { Route, Redirect } from 'react-router-dom';
import App from './app';
import SignIn from './pages/sign-in';
import Lottery from './pages/lottery';
import Setting from './pages/setting';

export const paths = {
  ROOT: '/',
  SIGN_IN: '/sign-in',
  LOTTERY: '/',
  SETTING: '/setting',
};

const authRequireRoutes = [paths.LOTTERY, paths.SETTING];
const noAuthRoutes = [paths.SIGN_IN];

// NazotokiBingoRoute
const NbRoute = ({ component: Component, authenticated, history, ...rest }) => (
  <Route
    {...rest}
    render={props =>
      (authRequireRoutes.includes(history.location.pathname) &&
        authenticated) ||
      (noAuthRoutes.includes(history.location.pathname) && !authenticated) ? (
        <Component {...props} />
      ) : (
        <Redirect
          to={{
            pathname: authRequireRoutes.includes(history.location.pathname)
              ? paths.SIGN_IN
              : paths.LOTTERY,
          }}
        />
      )
    }
  />
);

NbRoute.propTypes = {
  component: PropTypes.any,
  authenticated: PropTypes.bool,
  history: PropTypes.any,
};

export const Routes = ({ history, authenticated }) => (
  <ConnectedRouter history={history}>
    <App>
      <NbRoute
        path={paths.SIGN_IN}
        component={SignIn}
        authenticated={authenticated}
        history={history}
      />
      <NbRoute
        exact
        path={paths.LOTTERY}
        component={Lottery}
        authenticated={authenticated}
        history={history}
      />
      <NbRoute
        path={paths.SETTING}
        component={Setting}
        authenticated={authenticated}
        history={history}
      />
    </App>
  </ConnectedRouter>
);

Routes.propTypes = {
  authenticated: PropTypes.bool,
  history: PropTypes.any,
};



// WEBPACK FOOTER //
// ./src/views/routes.js